// <auto-generated>
// Code generated by EDHC (R) Code Generator.
// Changes may cause incorrect behavior and will be lost if the code is
// regenerated.
// Hash: 985384137
// </auto-generated>
import {
  StringLength,
  RegularExpression,
  Required,
  EmailAddress,
  MinValue,
} from 'carehub-shared/validators';

export class User {
  @Required()
  userId: string;
  @StringLength(256)
  userName: string;
  @StringLength(256)
  normalizedUserName: string;
  @StringLength(255)
  @EmailAddress()
  email: string;
  @StringLength(255)
  normalizedEmail: string;
  @Required()
  emailConfirmed: boolean;
  passwordHash: string;
  securityStamp: string;
  concurrencyStamp: string;
  phoneNumber: string;
  @Required()
  phoneNumberConfirmed: boolean;
  @Required()
  twoFactorEnabled: boolean;
  lockoutEnd: Date | string;
  @Required()
  lockoutEnabled: boolean;
  @Required()
  accessFailedCount: number;
  firstName: string;
  lastName: string;
  memberId: string;
  inactiveDate: Date | string;
  createdDate: Date | string;
  updatedDate: Date | string;
  createdUserId: string;
  updatedUserId: string;
  @StringLength(256)
  azureExternalId: string;
  @StringLength(12)
  phoneNumberExtension: string;
  displayName: string;
}

export function initializeNewUser(): User {
  const instance = new User();
  instance.userId = '00000000-0000-0000-0000-000000000000';
  instance.userName = '';
  instance.normalizedUserName = '';
  instance.email = '';
  instance.normalizedEmail = '';
  instance.emailConfirmed = false;
  instance.passwordHash = '';
  instance.securityStamp = '';
  instance.concurrencyStamp = '';
  instance.phoneNumber = '';
  instance.phoneNumberConfirmed = false;
  instance.twoFactorEnabled = false;
  instance.lockoutEnd = null;
  instance.lockoutEnabled = false;
  instance.accessFailedCount = null;
  instance.firstName = '';
  instance.lastName = '';
  instance.memberId = '00000000-0000-0000-0000-000000000000';
  instance.inactiveDate = null;
  instance.createdDate = null;
  instance.updatedDate = null;
  instance.createdUserId = '00000000-0000-0000-0000-000000000000';
  instance.updatedUserId = '00000000-0000-0000-0000-000000000000';
  instance.azureExternalId = '00000000-0000-0000-0000-000000000000';
  instance.phoneNumberExtension = '';
  instance.displayName = '';
  return instance;
}
